export default {
    carbonCredit: {
        view: 'Visualizar',
        edit: 'Editar',
        back: 'Voltar',
        preview: 'Pré-visualização',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        dashboard: 'Painel de Controle',
        select: 'Selecionar',
        submit: 'Enviar',
        save: 'Salvar',
        title: 'Crédito de Carbono',
        projects: 'Projetos',
        carbonProjectCredits: 'Créditos de Projeto de Carbono',
        carbonCreditProjects: 'Projetos de Crédito de Carbono',
        exportAs: 'Exportar como',
        downloadAsCSV: 'Baixar como CSV',
        downloadAsExcel: 'Baixar como Excel',
        downloadAsPDF: 'Baixar como PDF',
        registerNewProject: 'Registrar Novo Projeto',
        creditInfo: '*Este é o número aproximado de créditos. O número real de créditos pode ser diferente após verificação.',
        search: 'Pesquisar',
        projectTitle: 'Título do Projeto',
        projectType: 'Tipo de Projeto',
        country: 'País',
        totalCreditsGenerated: 'Total de Créditos Gerados',
        status: 'Status',
        descriptionPlaceholder: "Por favor, forneça uma descrição do projeto incluindo objetivos",
        filePreviewNotAvailable: 'Pré-visualização do arquivo não está disponível para este tipo de arquivo',
        active: 'Ativo',
        inactive: 'Inativo',
        pending: 'Pendente',
        proposed: 'Proposto',
        planned: 'Planejado',
        inProgress: 'Em Andamento',
        operational: 'Operacional',
        deactivated: 'Desativado',
        avoidedDeforestation: 'Deforestação Evitada',
        agroForestry: 'Agrofloresta',
        regenerativeAgriculture: 'Agricultura Regenerativa',
        agroforestry: 'Agrofloresta',
        regenerative_agriculture: 'Agricultura Regenerativa',
        redd: 'REDD',
        arr: 'ARR',
        biochar: 'Biochar',
        erw: 'ERW',
        grassland: 'Pastagens',
        projectDeletedSuccessfully: 'Projeto desativado com sucesso',
        projectUpdatedSuccessfully: 'Projeto atualizado com sucesso',
        projectRegisteredSuccessfully: 'Projeto registrado com sucesso',
        deactivateProjectError: 'Erro ao desativar projeto',
        deactivate: 'Desativar',
        deactivateProject: 'Desativar Projeto',
        deactivateConfirmation: 'Tem certeza de que deseja desativar este projeto?',
        delete: 'Excluir',
        deleteProject: 'Excluir Projeto',
        deleteConfirmation: 'Tem certeza de que deseja excluir este projeto? Esta ação não pode ser desfeita.',
        projectRemovedSuccessfully: 'Projeto excluído com sucesso',
        deleteProjectError: 'Erro ao excluir o projeto',
        changeStage: 'Alterar Fase',
        changeProjectStage: 'Alterar Fase do Projeto',
        projectStageUpdatedSuccessfully: 'Fase do projeto atualizada com sucesso',
        updateStageError: 'Erro ao atualizar a fase do projeto',
        stages: {
            planned: 'Planejado',
            operational: 'Operacional',
            inValidation: 'Em Validação',
            inVerification: 'Em Verificação',
            creditsIssued: 'Créditos Emitidos',
        },
        registerProject: 'Registrar um Novo Projeto',
        editProject: 'Editar Projeto',

        register: { 
            title: 'Registrar um Projeto',
            editTitle: 'Editar Projeto',
            projectTitle: 'Título do Projeto',
            projectType: 'Tipo de Projeto',
            pinVerification: 'Verificação por PIN',
            pinVerificationEnabled: 'Ativado',
            pinVerificationDisabled: 'Desativado',
            pinVerificationHint: 'Quando ativado, os agricultores devem verificar um PIN de 6 dígitos enviado para o e-mail deles antes de poderem assinar o contrato online.',
            description: 'Descrição',
            selectCountry: "Selecionar País",
            selectOrganization: 'Selecionar Organizações',
            status: 'Status',
            projectStage: 'Fase do Projeto',
            selectProjectStage: 'Selecionar Fase do Projeto',
            creditType: 'Tipo de Crédito',
            creditStart: 'Início do Crédito',
            creditEnd: 'Fim do Crédito',
            standardMethodology: 'Padrão/Metodologia',
            validationDocumentation: 'Documentação de Validação',
            vintage: 'Safra',
            currency: 'Moeda',
            projectInfo: 'Informações do Projeto',
            organizationDetails: 'Detalhes das Organizações',
            attachmentTitle: 'Anexo(s)',
            attachmentInfo: 'Você pode adicionar qualquer documento adicional, imagens, vídeo e arquivos de áudio relevantes para o projeto',
            documentation: 'Documentação',
            contractReviewDocumentsTitle: 'Documentos de Revisão de Contrato',
            contractReviewDocumentsInfo: 'Opcionalmente, marque qualquer anexo acima para também exibi-lo ao agricultor durante a revisão do contrato online, com título, descrição e ordem de exibição.',
            attachmentDocTitle: 'Título',
            attachmentDocDescription: 'Descrição',
            showToFarmerDuringContractReview: 'Mostrar ao agricultor durante a revisão do contrato',
            moveUp: 'Mover para cima',
            moveDown: 'Mover para baixo',
            displayOrder: 'Ordem de exibição',
            kml: {
                title: 'Área do Projeto (KML)',
                info: 'Envie um arquivo KML descrevendo o limite do projeto. O polígono será traçado no mapa abaixo e uma captura será salva junto com o projeto para que possa ser exibida publicamente.',
                uploadLabel: 'Arquivo KML',
                browse: 'Procurar um arquivo .kml',
                previewHint: 'Ao enviar, uma captura deste mapa será salva junto com o projeto.',
                savedSnapshot: 'Captura salva da área do projeto',
                remove: 'Remover KML',
                parseError: 'Não foi possível ler este arquivo KML. Verifique se ele contém polígonos ou coordenadas válidos.',
                areaLabel: 'Área do projeto',
                areaUnitLabel: 'Unidade',
                areaPlaceholder: 'Informe a área',
                uploaded: 'Enviado',
                fromKml: 'Do KML',
            },
            sdgsTitle: 'Objetivos de Desenvolvimento Sustentável (ODS)',
            sdgsInfo: 'Por favor, selecione apenas os objetivos relevantes para este projeto específico. As organizações terão acesso para ver apenas os objetivos vinculados a este projeto.',
            dataCollectionTitle: 'Ciclo de Coleta de Dados',
            dataCollectionInfo: 'Para participar do Programa de Crédito de Carbono, os agricultores devem fornecer dados históricos da fazenda durante o cadastro e continuar enviando atualizações periódicas de dados enquanto o programa permanecer ativo. Isso garante o rastreamento preciso do desempenho do carbono ao longo do tempo.',
            vintageYear: 'Ano da Safra',
            estimatedCredit: 'Créditos Estimados',
            pricePerCredit: 'Preço Por Crédito',
            moduleName: 'Nome do Módulo',
            futureData: 'Coleta de Dados Recorrentes Futuros',
            score: 'Pontuação',
            approval: 'Aprovação',

            projectAgreement: 'Acordo do Projeto',
            headerImage: 'Imagem do Cabeçalho',
            headerImageInfo: '(Tamanho da imagem do cabeçalho 1920 x 420 pixels. A imagem padrão será substituída pela nova imagem que você enviar)',
            headerImagePlaceholder: "Imagem do Cabeçalho Padrão",
            responsibleDimitraOffice: 'Escritório Dimitra Responsável',
            selectDimitraOffice: 'Selecionar Escritório Dimitra',
            makeASelection: 'Fazer uma Seleção',
            addNewDimitraOffice: 'Adicionar Novo Escritório Dimitra',
            editDimitraOffice: 'Editar Escritório Dimitra',
            officeName: 'Nome do Escritório',
            contactPerson: 'Nome da Pessoa de Contato',
            phoneNumber: 'Número de Telefone',
            email: 'E-mail',
            address: 'Endereço',
            officeNameRequired: 'Nome do escritório é obrigatório',
            contactPersonRequired: 'Nome da pessoa de contato é obrigatório',
            addressRequired: 'Endereço é obrigatório',
            phoneNumberRequired: 'Número de telefone é obrigatório',
            phoneNumberInvalid: 'Número de telefone é inválido',
            phoneNumberLength: 'Número de telefone deve ter pelo menos 10 dígitos',
            selectVintage: 'Selecionar Safra',
            officeAddedSuccessfully: 'Escritório Dimitra adicionado com sucesso',
            errorAddingOffice: 'Erro ao adicionar escritório Dimitra',
            searchOrganizations: 'Pesquisar Organizações',
            searchOrganizationsPlaceholder: 'Pesquisar por nome da organização...',
            noOrganizationsFound: 'Nenhuma organização encontrada',
            loadingOrganizations: 'Carregando organizações...',
            selectedOrganizations: 'Organizações Selecionadas',
            errorNegative: 'não pode ser negativo.',
            errorRequiredField: '{field} é obrigatório.',
            errorOrganizationRequired: 'Pelo menos uma organização deve ser selecionada.',
            errorVintageRequired: 'Pelo menos uma entrada de safra é obrigatória.',
            errorVintageFieldsRequired: 'Todos os campos da safra (ano, créditos, preço) são obrigatórios.',
            allOrganizations: 'Todas as Organizações',
            removal: 'Remoção',
            avoided: 'Evitado',
            mandatory: 'Obrigatório',
            scoreValidationError: 'Pontuação inválida para o módulo "{module}". A pontuação deve ser um número inteiro 0 ou maior.',
            approvalValidationError: 'Aprovação inválida para o módulo "{module}". A aprovação deve ser um número inteiro entre 0 e 100.',
            saveError: 'Falha ao salvar projeto',
            fileUploadFailed: 'Falha no Upload do Arquivo',
            unsupportedFileFormat: 'Formato de arquivo não suportado',
            errorUploadingFile: 'Erro ao fazer upload do arquivo',
            scoreError: {
                invalid: 'A pontuação deve ser um número válido',
                range: 'A pontuação deve ser 0 ou maior',
                wholeNumber: 'A pontuação deve ser um número inteiro'
            },
            approvalError: {
                invalid: 'A aprovação deve ser um número válido',
                range: 'A aprovação deve estar entre 0 e 100',
                wholeNumber: 'A aprovação deve ser um número inteiro'
            },
            selectStatus: 'Selecionar Status',
            selectCreditType: 'Selecionar Tipo de Crédito',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Padrão',
            browse: 'Navegar',
            currencyPlaceholder: 'USD',
            selectFile: 'Selecionar Arquivo',
            dragDropFiles: 'Arraste e solte arquivos aqui',
            hideDetails: 'Ocultar Detalhes',
            viewDetails: 'Ver Detalhes',
            website: 'Site',
            month: 'Mês(es)',
            year: 'Ano(s)',
        },

        error: 'Erro',
        success: 'Sucesso',
        remove: 'Remover',

        plotTreeMapping: {
            title: 'Mapeamento de Árvores por Parcela',
            techniciansPlots: 'Parcelas dos Técnicos',
            techniciansPlotsTitle: 'Parcelas dos Técnicos',
            plotNumber: 'Número da Parcela',
            addedBy: 'Adicionado Por',
            filterByDate: 'Filtrar por Data',
            selectDate: 'Selecionar Data',
            userRole: 'Função do Usuário',
            createdOn: 'Criado Em',
            removeTechnicianPlotMessage: 'Tem certeza de que deseja remover a parcela {plotNo}?',
            noTechnicianPlots: 'Nenhuma parcela de técnico encontrada',
            noTechnicianPlotsHint: 'As parcelas aparecem aqui quando estão vinculadas a uma solicitação de mapeamento atribuída a um técnico.',
            clearFilters: 'Limpar filtros',
            project: 'Projeto',
            selectProject: 'Selecionar projeto',
            projectRequired: 'O projeto é obrigatório',
            errorLoadingProjects: 'Falha ao carregar projetos',
            farm: 'Fazenda',
            errorLoadingFarmers: 'Falha ao carregar agricultores deste projeto',
            errorLoadingFarms: 'Falha ao carregar fazendas deste projeto',
            errorLoadingProjectBoundary: 'Não foi possível carregar o limite da área do projeto a partir do arquivo KML/KMZ salvo.',
            projectBoundaryHint: 'O contorno verde mostra a área aprovada do projeto do arquivo KML/KMZ registrado.',
            plotOutsideProjectArea: 'Parcela fora da área do projeto',
            plotOutsideProjectAreaMessage: 'A localização selecionada está fora do limite aprovado para {project}. Mova o pino para dentro da região designada.',
            errorPlotOutsideRegisteredFarm: 'Esta localização da fazenda está fora de todas as fazendas registradas do projeto. Escolha uma localização dentro de uma fazenda registrada.',
            errorCheckingFarmLocation: 'Não foi possível verificar a localização da fazenda. Tente novamente.',
            close: 'Fechar',
            plotLegendTitle: 'Legenda da parcela',
            plotMarkerLegendInfo: 'Parcelas medidas usam um marcador azul, sugeridas amarelo e auditadas verde. Os ícones coincidem com os marcadores selecionados no mapa.',
            measuredPlot: 'Parcela medida',
            suggestedPlot: 'Parcela sugerida',
            auditedPlot: 'Parcela auditada',
            imports: {
                importData: 'Import Data',
                dialogTitle: 'Import audited plots from sheet',
                downloadTemplate: 'Download CSV template',
                templateNote: 'Use columns ID, Original located, Real location, and Comments (header names are matched case-insensitive). ID is the numeric suffix of the tree-mapping request id (e.g. 56 for RE-ESTA056). Real location must be DMS pairs such as 21°41\'34.68"N, 104°31\'28.72"W. Rows with an empty Real location are skipped and not sent to the server.',
                selectFile: 'Select file',
                dropHere: 'or drop CSV / Excel here',
                invalidFileFormat: 'Please upload a .csv, .xls, or .xlsx file.',
                invalidHeaders: 'Invalid column headers',
                headerMismatch: "A linha de cabeçalho deve incluir ID e Localização real (consulte o modelo). Colunas esperadas: {expected}.",
                fileSelected: 'File selected',
                importing: 'Importing…',
                success: 'Import completed',
                partialSuccess: 'Import finished with some row errors',
                serverError: 'Import failed',
                rowErrorsSummary: "{count} linha(s) apresentaram erros. Verifique os detalhes da resposta da API ou corrija a planilha e tente novamente.",
                rowInvalidId: 'Invalid or missing ID on spreadsheet rows: {rows}. ID must be the numeric suffix of the request (e.g. 56).',
                noImportableRows: 'No rows to import. Add a value in Real location for rows you want imported; empty Real location rows are skipped.',
                emptyDataRows: 'No valid data rows found in the file.',
                cancel: 'Cancel',
                import: 'Import',
                removeFile: 'Remove file',
                resultDialogTitle: 'Import plots',
                importCompletedLabel: 'Import completed',
                recordsImportedLine: '{success} of {total} records imported',
                totalRecordsLabel: 'Total records',
                failedLabel: 'Failed',
                successLabel: 'Success',
                skippedLabel: 'Skipped',
                colSpreadsheetId: 'ID',
                colRequestId: 'Request ID',
                colPlotNo: 'Plot no.',
                colLocation: 'Location / detail',
                colStatus: 'Status',
                colAction: 'Action',
                statusSuccess: 'Success',
                statusFailed: 'Failed',
                statusSkipped: 'Skipped',
                retryImportTooltip: 'Import again',
                removeFromListTooltip: 'Remove from list',
                viewRequestTooltip: 'View request',
            },
        },

        projectInfo: {
            title: 'Informações do Projeto',
            organizationDetail: 'Detalhe da Organização',
            subOrganizations: 'Sub-organizações',
            search: 'Pesquisar',
            organizations: 'Organizações',
            users: 'Usuários',
            registrationDate: 'Data de Registro',
            close: 'Fechar',
            country: 'País',
            organizationsAddress: 'Endereço das Organizações',
            blockchainAddress: 'Endereço Blockchain',
            creditType: 'Tipo de Crédito',
            projectType: 'Tipo de Projeto',
            officeName: 'Nome do Escritório',
            contactPersonName: 'Nome da Pessoa de Contato',
            contactNumber: 'Número de Contato',
            email: 'E-mail',
            address: 'Endereço',
            website: 'Site',
            companyName: 'Nome da Empresa',
            companyAddress: 'Endereço da Empresa',
            web: 'Site',
            vintageYear: 'Ano da Safra',
            estimatedCredits: 'Créditos Estimados',
            pricePerCredit: 'Preço Por Crédito',
            module: 'Módulo',
            recurring: 'Recorrente',
            score: 'Pontuação',
            approval: 'Aprovação',
            responsibleDimitraOffice: 'Escritório Dimitra Responsável',
            status: 'Status',
            standardMethodology: 'Padrão/Metodologia',
            validationDocumentation: 'Documentação de Validação',
            creditStart: 'Início do Crédito',
            creditEnd: 'Fim do Crédito',
            attachmentTitle: 'Anexo(s)',
            sdgsTitle: 'Objetivos de Desenvolvimento Sustentável (ODS)',
            dataCollectionTitle: 'Ciclo de Coleta de Dados',
            dataCollectionInfo: 'Para participar do Programa de Crédito de Carbono, os agricultores devem fornecer dados históricos da fazenda durante o cadastro e continuar enviando atualizações periódicas de dados enquanto o programa permanecer ativo. Isso garante o rastreamento preciso do desempenho do carbono ao longo do tempo.',
            vintage: 'Safra',
            moduleName: 'Nome do Módulo',
            futureData: 'Coleta de Dados Recorrentes Futuros',
            estimatedCredit: 'Créditos Estimados',
        },

        user: {
            title: 'Usuário(s) de Crédito de Carbono',
            selectOrganization: 'Selecionar Organização',
            selectProject: 'Selecionar Projeto',
            allUsers: 'Todos os Usuários',
            activeUsers: 'Usuários Ativos',
            deactivatedUsers: 'Usuários Desativados',
            pendingUsers: 'Usuários Pendentes',
            search: 'Pesquisar',
            farmerName: 'Nome do Agricultor',
            farmName: 'Nome da Fazenda',
            organizations: 'Organizações',
            country: 'País',
            projectTitle: 'Título do Projeto',
            registerProject: 'Registrar um Novo Projeto',
            actions: 'Ações',
            noData: 'Nenhum usuário encontrado.',
            view: 'Visualizar',
            viewLandPermit: 'Ver Título de Propriedade / Permissão',
            edit: 'Editar',
            deactivate: 'Desativar',
            deactivateUser: 'Desativar Usuário',
            deactivateConfirmation: 'Tem certeza de que deseja desativar este usuário?',
            activate: 'Ativar',
            activateUser: 'Ativar Usuário',
            activateConfirmation: 'Tem certeza de que deseja ativar este usuário?',
            deactivatedSuccessfully: 'Usuário desativado com sucesso',
            activatedSuccessfully: 'Usuário ativado com sucesso',
            deactivationFailed: 'Erro ao desativar usuário',
            exportAsPdf: 'Exportar como PDF',
            projectDetails: 'Detalhes do Projeto',
            dateJoined: 'Data de Adesão',
            cropGrowingPractice: 'Prática de Cultivo',
            farm: 'Fazenda',
            rejectAll: 'REJEITAR TUDO',
            acceptAll: 'ACEITAR TUDO',
            confirmRejectAll: 'Você está prestes a rejeitar solicitações para todas as fazendas se juntarem ao projeto de crédito de carbono. Esta ação excluirá todas as fazendas enviadas pelo agricultor nesta solicitação. Tem certeza de que deseja continuar?',
            confirmAcceptAll: 'Você está prestes a aceitar solicitações para todas as fazendas se juntarem ao projeto de crédito de carbono. Esta ação incluirá todas as fazendas enviadas pelo agricultor nesta solicitação. Tem certeza de que deseja continuar?',
            dateOfRegistration: 'Data de Registro',
            farmRegistrationId: 'ID de Registro da Fazenda',
            dimitraFarmId: 'ID da Fazenda Dimitra',
            notTheFarmer: "Eu não sou o Agricultor",
            farmerFirstName: 'Primeiro Nome do Agricultor',
            farmerMiddleName: 'Nome do Meio do Agricultor',
            farmerLastName: 'Sobrenome do Agricultor',
            farmerRegistrationId: 'ID de Registro do Agricultor',
            dimitraFarmerId: 'ID do Agricultor Dimitra',
            farmGeofence: 'Geocerca da Fazenda',
            viewGeofence: 'Ver Geocerca',
            totalFarmSize: 'Tamanho Total da Fazenda',
            mainGoals: 'Quais são Seus Objetivos Principais',
            ownershipType: 'Tipo de Propriedade',
            certifications: 'Certificação(ões)',
            productionType: 'Tipo de Produção',
            landTitle: 'Título de Propriedade',
            farmLocationAddress: 'Endereço de Localização da Fazenda',
            farmCoordinate: 'Coordenada da Fazenda',
            farmerAgreement: 'Acordo do Agricultor',
            viewSignedAgreement: 'Ver acordo assinado enviado com a solicitação.',
            viewAgreement: 'VER ACORDO',
            acceptanceStatus: 'Status de Aceitação',
            currentStatus: 'Status Atual',
            reject: 'REJEITAR',
            accept: 'ACEITAR',
            farmActivitySubmissions: 'Submissões de Atividade da Fazenda',
            farmActivitySubmissionsDesc: 'Registros enviados de práticas agrícolas e atualizações necessárias para verificação de crédito de carbono.',
            viewFarmData: 'VER DADOS DA FAZENDA',
            farmData: 'Dados da Fazenda',
            farmDataDesc: 'Crie seus relatórios integrando dados de produção de várias fontes. Selecione uma ou múltiplas fontes para compilar uma lista completa de locais de produção para seus relatórios.',
            crops: 'Culturas',
            sowing: 'Semeadura',
            seedling: 'Muda',
            fertilizer: 'Fertilizante',
            fertilizerError: 'Submissão incompleta: Informações de fertilizante para 4 meses estão faltando na entrada do agricultor.',
            harvesting: 'Colheita',
            livestock: 'Gado',
            equipment: 'Equipamento',
            projectRequests: 'Solicitações de Projeto',
            userNameAndId: 'Nome de Usuário e ID',
            email: 'E-mail',
            userRole: 'Perfil de Usuário',
            status: 'Status',
            userRegistrationDate: 'Data de Registro de Usuário',
            pending: 'Pendente',
            deactivated: 'Desativado',
            active: 'Ativo',
            statusInProgress: 'Em Progresso',
            statusInReview: 'Em Revisão',
            statusApprovedWithWarning: 'Aprovado (Com Aviso)',
            statusApproved: 'Aprovado',
            statusRequireUpdate: 'Atualização Necessária',
            statusRejected: 'Rejeitado',
            selectProjectTypeFirst: 'Selecione o Tipo de Projeto Primeiro',
            noFarmsToReject: 'Nenhuma fazenda para rejeitar',
            allFarmsRejected: 'Todas as fazendas rejeitadas com sucesso',
            rejectAllError: 'Falha ao rejeitar todas as fazendas',
            noFarmsToAccept: 'Nenhuma fazenda para aceitar',
            allFarmsAccepted: 'Todas as fazendas aceitas com sucesso',
            acceptAllError: 'Falha ao aceitar todas as fazendas',
            farmNotFound: 'Fazenda não encontrada ou não associada ao projeto',
            farmAlreadyRejected: 'A fazenda já foi rejeitada',
            farmRejected: 'Fazenda rejeitada com sucesso',
            rejectFarmError: 'Falha ao rejeitar a fazenda',
            farmAlreadyAccepted: 'A fazenda já foi aceita',
            farmAccepted: 'Fazenda aceita com sucesso',
            acceptFarmError: 'Falha ao aceitar a fazenda',
        },

        manageTrees: {
            pageTitle: 'Gerenciar Árvores',
            addNewTree: 'Adicionar Nova Árvore',
            updateTreeInfo: 'Atualizar Informações da Árvore',
            treeList: 'Lista de Árvores',
            importInBulk: 'Importar em Massa',
            downloadTrees: 'Baixar Árvores',
            save: 'Salvar',
            cancel: 'Cancelar',
            treeId: 'ID da Árvore',
            project: 'Projeto',
            search: 'Pesquisar',
            treeIdHeader: 'ID da Árvore',
            treeTypeAndSpecies: 'Tipo e Espécie de Árvore',
            geoCoordinates: 'Coordenadas Geográficas',
            addedBy: 'Adicionado Por',
            datePlanted: 'Data de Plantio',
            view: 'Ver',
            edit: 'Editar',
            delete: 'Excluir',
            currentPage: 'Página Atual',
            allPages: 'Todas as Páginas',
            none: 'Nenhum',
            selected: 'Selecionado(s)',
            deleteTree: 'Excluir Árvore',
            deleteTreeConfirm: 'Tem certeza de que deseja excluir esta árvore? Esta ação não pode ser desfeita.',
            importTreesInBulk: 'Importar Árvores em Massa',
            uploadCsvOrExcel: 'Carregar arquivo CSV ou Excel',
            import: 'Importar',
            treeDeletedSuccessfully: 'Árvore excluída com sucesso.',
            treeDeleteFailed: 'Falha ao excluir a árvore.',
            downloadingTrees: 'Baixando árvores selecionadas...',
            importStarted: 'Importação iniciada.',
            selectAllPagesNotSupported: 'Selecionar todas as páginas ainda não é suportado.',
            idLabel: 'ID (Ex., Id da árvore)',
            additionalId: 'ID Adicional',
            selectFarm: 'Selecionar Fazenda',
            selectZone: 'Selecionar Zona',
            gpsCoordinates: 'Coordenadas GPS',
            gpsHint: 'ex. 26.4443186, 87.2869355',
            locationInformation: 'Informações de Localização',
            altitude: 'Altitude',
            seedlingName: 'Nome da muda',
            selectTreeType: 'Selecionar Tipo de Árvore',
            selectTreeSpecies: 'Selecionar Espécie de Árvore',
            selectHealthCondition: 'Selecionar Condição de Saúde',
            includeIn: 'Onde você gostaria de incluir esta árvore?',
            additionalNotes: 'Notas Adicionais',
            attachImages: 'Anexar Imagens',
            selectFilesToUpload: 'Selecionar Arquivo(s) para Carregar',
            dragAndDrop: 'ou arraste e solte aqui',
            enterHere: 'Digite aqui',
            makeASelection: 'Faça uma seleção',
            avocado: 'Abacate',
            coffee: 'Café',
            cacao: 'Cacau',
            fruitTree: 'Árvore Frutífera',
            timber: 'Madeira',
            other: 'Outro',
            guatemalan: 'Guatemalteco',
            hass: 'Hass',
            reed: 'Reed',
            fuerte: 'Fuerte',
            healthy: 'Saudável',
            moderate: 'Moderado',
            poor: 'Ruim',
            dead: 'Morto',
            urban: 'Urbano',
            rural: 'Rural',
            forest: 'Floresta',
            farmland: 'Terra Agrícola',
            hillside: 'Encosta',
            carbonCreditProject: 'Projeto de Crédito de Carbono',
            plotTreeMappingOption: 'Mapeamento de Árvores em Parcela',
            both: 'Ambos',
            fieldRequired: 'Este campo é obrigatório.',
            treeCreatedSuccessfully: 'Árvore criada com sucesso.',
            treeCreateFailed: 'Falha ao criar a árvore.',
            treeUpdatedSuccessfully: 'Árvore atualizada com sucesso.',
            treeUpdateFailed: 'Falha ao atualizar a árvore.',
            treeLoadFailed: 'Falha ao carregar os dados da árvore.',
            clusterDetails: 'Detalhes do Cluster',
            trees: 'Árvores',
            primaryTreeType: 'Tipo de Árvore Principal',
            treeType: 'Tipo de árvore',
            bulkTreeDataImport: 'Importação em massa de dados de árvores',
            downloadTemplateToBulkImportMessage: 'Baixe e use os modelos abaixo para importar árvores em massa.',
            selectTemplate: 'Selecionar modelo',
            bulkImportedSuccessMessage: '{count} árvores foram importadas com sucesso.',
            back: 'Voltar',
            treeDetails: 'Detalhes da Árvore',
            treeHistory: 'Histórico da Árvore',
            viewHistory: 'Ver Histórico',
            provideUpdates: 'Fornecer Atualizações',
            programType: 'Tipo de Programa',
            treeImages: 'Imagens da Árvore',
            treeImage: 'Imagem da Árvore',
            treeQrCode: 'Código QR da Árvore',
            treeAddedBy: 'Árvore adicionada por',
            username: 'Nome de usuário',
            downloadImage: 'Baixar Imagem',
            dimitraAssetId: 'ID do Ativo Dimitra',
            zone: 'Zona',
            treeSpecies: 'Espécie da Árvore',
            dateOfPlantation: 'Data de Plantio',
            ageOfTree: 'Idade da Árvore',
            healthCondition: 'Condição de Saúde',
            updatedBy: 'Atualizado por',
            updatedAt: 'Atualizado em',
            startDate: 'Data de Início',
            endDate: 'Data de Fim',
            whereWouldYouLikeToIncludeThisTree: 'Onde você gostaria de incluir esta árvore?',
            selectModule: 'Selecionar módulo',
            selectProject: 'Selecionar projeto',
            selectNftProject: 'Selecionar projeto NFT',
            loadingMore: 'Carregando mais...',
            fetchNftListFailed: 'Não foi possível buscar a lista de NFT agora.',
            projectName: 'Nome do Projeto',
        },
    }
} 